<template>
  <PulldownForm v-if="question.question.type === 'dropdown'" />
  <SelectForm v-else-if="question.question.type === 'select'" />
  <MultipleForm v-else-if="question.question.type === 'multiple'" />
  <OrderForm v-else-if="question.question.type === 'order'" />
  <InputForm v-else-if="question.question.type === 'input'" />
  <SelfForm v-else-if="question.question.type === 'self'" @setSend="setSend" />
</template>

<script>
import PulldownForm from "./Forms/PulldownForm.vue";
import SelectForm from "./Forms/SelectForm.vue";
import MultipleForm from "./Forms/MultipleForm.vue";
import OrderForm from "./Forms/OrderForm.vue";
import InputForm from "./Forms/InputForm.vue";
import SelfForm from "./Forms/SelfForm.vue";

export default {
  computed: {
    question() {
      return this.$store.getters.question;
    }
  },
  components: {
    PulldownForm,
    SelectForm,
    MultipleForm,
    OrderForm,
    InputForm,
    SelfForm
  },
  methods: {
    setSend() {
      this.$emit('setSend');
    }
  }
};
</script>
